import React, { createContext, useState, useEffect, useContext } from 'react';
import api from '../services/api';
import { applyStandardThemeDefault } from '../utils/appearanceDefaults';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const loadUser = async () => {
            const token = localStorage.getItem('token');
            const savedUser = localStorage.getItem('user');

            if (token && savedUser) {
                try {
                    // Opcional: Validar token com o backend
                    // await api.get('/auth/me'); 
                    const restoredUser = JSON.parse(savedUser);
                    applyStandardThemeDefault(restoredUser);
                    setUser(restoredUser);
                    setIsAuthenticated(true);
                } catch (error) {
                    console.error('Erro ao restaurar sessão (AuthContext):', error);
                    logout();
                }
            }
            setLoading(false);
        };

        loadUser();
    }, []);

    const iniciarSessao = (token, user) => {
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));

        applyStandardThemeDefault(user);
        setUser(user);
        setIsAuthenticated(true);
    };

    const login = async (username, password) => {
        try {
            const response = await api.post('/auth/login', { username, password });

            if (response.data.success) {
                const { token, user } = response.data;
                iniciarSessao(token, user);
                return { success: true, user };
            }
            // Palavra-passe certa; falta o código da app autenticadora ou do email.
            if (response.data.dois_passos) {
                const { desafio, metodo, email } = response.data;
                return { success: false, doisPassos: { desafio, metodo, email } };
            }
            return { success: false, message: response.data.message };
        } catch (error) {
            console.error('Erro no login (AuthContext):', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Erro ao conectar ao servidor'
            };
        }
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
        setIsAuthenticated(false);
    };

    // Verifica se o utilizador tem permissão para aceder a um módulo
    // Se permissoes for null/undefined, o utilizador vê tudo (comportamento padrão)
    // Admin vê sempre tudo
    const hasPermission = (modulePath) => {
        if (!user) return false;
        if (user.role === 'admin') return true;
        if (!user.permissoes) return true; // sem restrições definidas = acesso total
        return user.permissoes[modulePath] !== false;
    };

    return (
        <AuthContext.Provider value={{ user, login, iniciarSessao, logout, isAuthenticated, loading, hasPermission }}>
            {children}
        </AuthContext.Provider>
    );
};
